import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faUserTie } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

interface SampleWeeklyCheckInPreviewModalHeaderProps {
  type: string;
  isCollapsed?: boolean;
  onCollapseClick?: (isCollapsed: boolean) => void;
  hideCollapseButton?: boolean;
}

const SampleWeeklyCheckInPreviewModalHeader = ({
  type,
  isCollapsed,
  onCollapseClick,
  hideCollapseButton,
}: Readonly<SampleWeeklyCheckInPreviewModalHeaderProps>) => {
  const getContentInfo = (): {
    howItWorks: string | null;
    idealFor: string | null;
    title: string | null;
  } => {
    let howItWorks: string | null = null;
    let idealFor: string | null = null;
    let title: string | null = null;
    switch (type) {
      case "check-in-email":
        howItWorks =
          "Invitation to have a check-in with Coach Bo that is simple and mobile-friendly.";
        idealFor = "All employees who receive check-ins.";
        title = "Invite Email";
        break;
      case "sample-weekly-check-in-chat":
        howItWorks =
          "A 2 minute, supportive, structured chat with Coach Bo to find out how you’re feeling, what you've been up to, and any blockers or support needs.";
        idealFor = "All employees who receive check-ins.";
        title = "Check-in Chat";
        break;
      case "employee-conversation-summary-report":
        howItWorks =
          "Delivered in-product after each checkin is completed. A simple summary of every conversation with Bo including an individual’s primary focus, wins to celebrate, support needs, and conversation starters. Great for 1:1’s, personal development plans and performance reviews.";
        idealFor = "All employees who receive check-ins.";
        title = "Employee Conversation Summary Report";
        break;
      case "team-leader-report":
        howItWorks =
          "Intelligence reports delivered via email and in-product to help managers understand the state of their team and know where, and on whom, to focus.";
        idealFor =
          "Team Leaders and Managers overseeing multiple direct reports.";
        title = "Team Leader Check-in Report";
        break;
      case "senior-manager-report":
        howItWorks =
          "Intelligence reports delivered via email and in-product enabling people leading managers to see trends, patterns, key wins, and support needs across their full span of control.";
        idealFor =
          "VP’s, Directors, Department Heads and senior managers overseeing multiple teams.";
        title = "Senior Manager Check-in Report";
        break;
      case "executive-report":
        howItWorks =
          "Company-wide engagement pulse and organizational health indicators. Early warning system for retention risks while tracking how initiatives resonate across departments.";
        idealFor = "C-Suite, VPs, and Senior Leadership";
        title = "Executive Check-in Report";
        break;
    }

    return { howItWorks, idealFor, title };
  };

  const { howItWorks, idealFor, title } = getContentInfo();

  return (
    <div className="sample-weekly-check-in-preview-modal-header">
      <div className="d-flex justify-content-between">
        {title && <h3>{title}</h3>}
        {!hideCollapseButton && (
          <button
            className="no-style-button"
            onClick={() => {
              onCollapseClick?.(!isCollapsed);
            }}
            style={{ height: "fit-content" }}
          >
            <FontAwesomeIcon
              icon={isCollapsed ? faChevronDown : faChevronUp}
              className="me-2"
            />
          </button>
        )}
      </div>
      {!isCollapsed ? (
        <div className="sample-weekly-check-in-preview-modal-header__content mt-3">
          <div className="sample-weekly-check-in-preview-modal-header__section">
            {howItWorks && (
              <p className="sample-weekly-check-in-preview-modal-header__section-message">
                <FontAwesomeIcon icon={faAddressCard} className="me-2" />
                <span className="fw-bold">How it works: </span>
                {howItWorks}
              </p>
            )}
          </div>
          <div className="divider" />
          <div className="sample-weekly-check-in-preview-modal-header__section">
            {idealFor && (
              <p className="sample-weekly-check-in-preview-modal-header__section-message">
                <FontAwesomeIcon icon={faUserTie} className="me-2" />
                <span className="fw-bold">Ideal for: </span>
                {idealFor}
              </p>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SampleWeeklyCheckInPreviewModalHeader;
